import { getComposeEvent } from 'owa-calendar-compose-store-manager';

export let getItemId = () => {
    const event = getComposeEvent(null /* formId */);
    return event.ItemId ? event.ItemId.Id : null;
};
